//@ts-nocheck
import "./style.css";
import React from "react";
import Atom from "../atom";

export default function GAlert(props) {
  const { onClose, type, message } = props;

  return (
    <Atom.Div className="position-absolute gAlertWrapper">
      {/*@ts-ignore*/}
      <Atom.Alert
        // @ts-ignore
        type={type}
        onClose={onClose}
        message={message}
      />
    </Atom.Div>
  );
}
